import Utils from "@/utils/Utils";
import EventBus from "@/commons/EventBus";
import store from "@/store";

let modals = [];

export default {

    openModal(component, params = {}, width = 800, height = 'auto') {

        width = component?.modal?.width || width;
        const clickToClose = component?.modal?.escapable !== undefined ? component.modal.escapable : true;

        const clone = Utils.safetyClone(component);
        const name = 'modal-' + Utils.uuid();
        modals.push(name);

        return new Promise((resolve) => {
            EventBus.$modal.show(clone, params,
                {
                    maxWidth: width,
                    width: "95%",
                    name,
                    clickToClose,
                    scrollable: false,
                    draggable: '.modal-header',
                    height: height,
                    adaptive: true,
                    classes: [store.getLayoutColor()]
                },
                {
                    'before-close': event => {
                        modals = modals.filter(e => e !== event.name);
                        return resolve(event.params);
                    }
                });
        });
    },

    openConfirmationModal(component, params = {}) {
        return this.openModal(component, params, 400, '250px');
    },

    closeModal(result) {
        EventBus.$modal.hide(modals.pop(), result);
    },

    closeAllModals() {
        modals.forEach(id => EventBus.$modal.hide(id));
    },

}